import { m8API } from 'services/production/m8';
import { SubmitRefundFormService } from 'types/services';

export const submitRefundForm: SubmitRefundFormService = async ({
  clientId,
  refundId,
  values,
}) => {
  if (refundId) {
    await m8API.admin.updateRefund({
      idRefund: refundId,
      comment: values.comment,
      amount: Number(values.amount),
    });
  } else {
    await m8API.admin.refund({
      idUser: clientId,
      comment: values.comment,
      amount: Number(values.amount),
    });
  }
};
